var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, ICON_SIZES, } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Chip, IconButton, Tab, Tabs, Typography } from '@mui/material';
var getHorizontalMenuTabStyles = function (variant, numbered) {
    switch (variant) {
        case 'box':
            return {
                container: boxContainerSx,
                tab: boxTabSx,
                tabs: boxTabsSx,
                scroll: false,
            };
        case 'minimal':
            return {
                container: minimalContainerSx,
                tab: minimalTabSx,
                tabs: minimalTabsSx,
                scroll: false,
            };
        case 'minimal-highlighted':
            return {
                container: minimalHighlightedContainerSx,
                tab: minimalHighlightedTabSx(numbered),
                tabs: minimalHighlightedTabsSx,
                scroll: true,
            };
        case 'filter':
            return {
                container: filterContainerSx,
                tab: filterTabSx,
                tabs: filterTabsSx,
                tabIndicator: filterTabIndicatorSx,
                scroll: false,
            };
        case 'simple':
            return {
                container: simpleContainerSx,
                tab: simpleTabSx,
                tabs: simpleTabsSx,
                tabIndicator: simpleTabIndicatorSx,
                scroll: false,
            };
    }
};
export function HorizontalMenuTabs(_a) {
    var setValue = _a.setValue, tabs = _a.tabs, value = _a.value, chipConfig = _a.chipConfig, variant = _a.variant, numbered = _a.numbered, disabledTabs = _a.disabledTabs, containerSxOverride = _a.containerSxOverride, tabIndicators = _a.tabIndicators, onCloseTab = _a.onCloseTab, closableTabs = _a.closableTabs, id = _a.id;
    var styles = getHorizontalMenuTabStyles(variant, numbered);
    var handleChange = function (e, newValue) {
        e.preventDefault();
        setValue(newValue);
    };
    return (_jsxs(Box, { id: id, sx: [styles.container, containerSxOverride].filter(Boolean), children: [_jsx(Tabs, { value: value === -1 ? 0 : value, onChange: handleChange, sx: styles.tabs, TabIndicatorProps: {
                    sx: styles.tabIndicator,
                }, variant: styles.scroll ? 'scrollable' : 'standard', scrollButtons: false, allowScrollButtonsMobile: styles.scroll, children: tabs.map(function (t, index) {
                    var indicator = tabIndicators === null || tabIndicators === void 0 ? void 0 : tabIndicators[index];
                    var tabSlug = t.toLowerCase().replace(/\s+/g, '-');
                    var isClosable = (closableTabs === null || closableTabs === void 0 ? void 0 : closableTabs[index]) && onCloseTab;
                    var closeButton = isClosable ? (_jsx(IconButton, { id: "".concat(id ? "".concat(id, "-") : '', "tab-close-").concat(tabSlug), size: "small", onClick: function (e) {
                            e.stopPropagation();
                            onCloseTab(index);
                        }, sx: tabCloseButtonSx, children: _jsx(AppIcon, { iconName: "XClose", diameter: "12px", color: "Gray/700", strokeWidth: "regular" }) })) : null;
                    var baseLabel = numbered ? (_jsxs(Box, { sx: numberedTabLabelSx, children: [_jsx(Box, { sx: numberedTabCircleSx, children: _jsx(Typography, { variant: "text-xs-medium", children: index + 1 }) }), t] })) : indicator ? (_jsxs(Box, { sx: tabWithIndicatorSx, children: [indicator, t] })) : (t);
                    var label = closeButton ? (_jsxs(Box, { sx: tabWithIndicatorSx, children: [baseLabel, closeButton] })) : (baseLabel);
                    return (_jsx(Tab, { id: "".concat(id ? "".concat(id, "-") : '', "tab-").concat(tabSlug), label: label, sx: [styles.tab, tabTruncateSx, isClosable && closableTabSx].filter(Boolean), disableRipple: true, disabled: disabledTabs === null || disabledTabs === void 0 ? void 0 : disabledTabs.includes(t) }, "".concat(t, "-").concat(index)));
                }) }), chipConfig && (_jsx(Chip, { id: id ? "".concat(id, "-scroll-chip") : 'scroll-chip', variant: "pill", size: "lg", type: "leading", label: chipConfig.label, icon: chipConfig.iconName && (_jsx(AppIcon, { iconName: chipConfig.iconName, diameter: "12px", color: chipConfig.iconColor || 'Warning/500', strokeWidth: chipConfig.strokeWidth || 'regular' })), sx: [chipSx, chipConfig.chipSxOverride].filter(Boolean), onClick: chipConfig.onClick }))] }));
}
var minimalTabSx = function (_a) {
    var typography = _a.typography, backrs = _a.backrs;
    return (__assign(__assign({}, typography['text-md-semibold']), { textTransform: 'none', color: backrs.colors['Colors/Foreground/fg-brand-secondary'], '&.Mui-selected': {
            color: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        }, '&:hover': {
            color: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        } }));
};
var minimalHighlightedTabSx = function (numbered) {
    return function (_a) {
        var backrs = _a.backrs, typography = _a.typography;
        return (__assign(__assign({}, typography['text-md-semibold']), { textTransform: 'none', color: backrs.colors['Gray/500'], pt: 0, pb: numbered ? backrs.spacing['spacing-xs'] : backrs.spacing['spacing-xl'], minHeight: numbered ? '36px' : '30px', height: numbered ? '36px' : '30px', '&.Mui-selected': {
                color: backrs.colors['Brand/700'],
            } }));
    };
};
var boxTabSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({ border: "1px solid ".concat(backrs.colors['Gray/300']), '&:first-of-type': {
            borderRadius: '8px 0px 0px 8px',
        }, '&:last-of-type': {
            borderRadius: '0px 8px 8px 0px',
        } }, typography['text-sm-semibold']), { color: backrs.colors['Gray/700'], transition: 'all 0.3s ease-in-out', backgroundColor: backrs.colors['Colors/Background/bg-primary'], '&.Mui-selected': {
            backgroundColor: "".concat(backrs.colors['Colors/Background/bg-active']),
            color: backrs.colors['Gray/700'],
        }, '&:hover': {
            backgroundColor: "".concat(backrs.colors['Gray/50']),
            color: backrs.colors['Gray/700'],
        }, textTransform: 'none' }));
};
var minimalContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        containerType: 'inline-size',
        borderBottom: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quaternary']),
        alignItems: 'flex-start',
        flexWrap: 'wrap-reverse',
        pt: {
            sm: backrs.spacing['spacing-2xl'],
        },
        display: {
            xs: 'none',
            md: 'flex',
        },
        '@container (max-width: 900px)': {
            display: 'none',
        },
        justifyContent: 'space-between',
        maxWidth: "calc(936px - ".concat(backrs.spacing['spacing-7xl'], ") !important"),
        justifyItems: 'center',
        width: '-webkit-fill-available',
        alignSelf: 'center',
        position: 'sticky',
        top: 0,
        backgroundColor: backrs.colors['Beige/25'],
        zIndex: 10,
        mx: {
            xs: backrs.spacing['spacing-4xl'],
        },
        boxSizing: 'border-box',
    });
};
var minimalHighlightedContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        borderBottom: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quaternary']),
        overflowX: 'auto',
        overflowY: 'hidden',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
            height: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: backrs.colors['Gray/300'],
            borderRadius: '2px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: backrs.colors['Gray/400'],
        },
    });
};
var boxContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'flex-start',
        borderRadius: backrs.radius['radius-md'],
        border: "1px solid ".concat(backrs.colors['Gray/300']),
        boxShadow: backrs.shadows['shadow-xs-skeuomorphic'],
        pt: {
            sm: backrs.spacing['spacing-none'],
        },
        position: 'sticky',
        top: 0,
        width: 'fit-content',
        overflow: 'hidden',
    });
};
var minimalTabsSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-md'],
        textTransform: 'none',
        flex: 1,
        '& .MuiTabs-indicator': {
            backgroundColor: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        },
    });
};
var minimalHighlightedTabsSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-md'],
        textTransform: 'none',
        flex: 1,
        minHeight: 'unset',
        '& .MuiTabs-indicator': {
            backgroundColor: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        },
        '& .MuiTabs-flexContainer': {
            minHeight: 'unset',
        },
    });
};
var boxTabsSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        '& .MuiTabs-indicator': {
            display: 'none',
        },
        '& .MuiTab-root': {
            padding: backrs.spacing['spacing-none'],
        },
        '& .MuiButtonBase-root': {
            padding: backrs.spacing['spacing-none'],
            paddingX: {
                xs: backrs.spacing['spacing-sm'],
                lg: backrs.spacing['spacing-xl'],
            },
        },
    });
};
var chipSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        borderColor: backrs.colors['Colors/Border/border-primary'],
        '& .MuiChip-label': {
            color: backrs.colors['Colors/Text/text-secondary'],
            display: 'none',
        },
        '@container (min-width: 900px)': {
            '& .MuiChip-label': {
                display: 'block',
            },
        },
        backgroundColor: backrs.colors['Colors/Background/bg-primary'],
        alignSelf: 'center',
    });
};
var filterContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        backgroundColor: backrs.colors['Colors/Background/bg-secondary-alt'],
        alignItems: 'flex-start',
        borderRadius: backrs.radius['radius-md'],
        border: "1px solid ".concat(backrs.colors['Beige/950']),
        p: backrs.spacing['spacing-xs'],
        position: 'sticky',
        top: 0,
        transition: 'none',
        zIndex: 1,
    });
};
var filterTabIndicatorSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '100%',
        top: 0,
        backgroundColor: 'transparent',
        border: "1px solid ".concat(backrs.colors['Beige/950']),
        borderRadius: backrs.radius['radius-sm'],
        transition: 'left 0.3s ease, width 0.3s ease',
        zIndex: 1,
    });
};
var filterTabSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({}, typography['text-sm-semibold']), { color: backrs.colors['Colors/Text/text-quaternary'], backgroundColor: 'transparent', transition: 'color 0.5s ease', '&:hover': {
            backgroundColor: 'transparent',
            color: backrs.colors['Colors/Text/text-secondary'],
        }, textTransform: 'none', py: backrs.spacing['spacing-md'], px: backrs.spacing['spacing-lg'], minWidth: 'unset', minHeight: 'unset', '&.Mui-selected': {
            color: backrs.colors['Colors/Text/text-secondary'],
        }, marginRight: { sm: backrs.spacing['spacing-md'] }, '&:last-of-type': {
            marginRight: backrs.spacing['spacing-none'],
        } }));
};
var filterTabsSx = {
    textTransform: 'none',
    flex: 1,
    '&.MuiTabs-root': {
        minWidth: 'unset',
        minHeight: 'unset',
    },
    transition: 'none',
};
var simpleContainerSx = function (theme) { return (__assign(__assign({}, minimalContainerSx(theme)), { backgroundColor: theme.backrs.colors['Brand/25'], maxWidth: '100% !important', marginLeft: '0 !important', marginRight: '0 !important', overflowX: 'auto', overflowY: 'hidden', scrollBehavior: 'smooth', '&::-webkit-scrollbar': {
        height: '4px',
    }, '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
    }, '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.backrs.colors['Gray/300'],
        borderRadius: '2px',
    }, '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.backrs.colors['Gray/400'],
    }, alignItems: 'flex-start', flexWrap: 'nowrap' })); };
var simpleTabSx = function (theme) { return (__assign(__assign({}, minimalTabSx(theme)), { backgroundColor: 'transparent', color: theme.backrs.colors['Colors/Text/text-quaternary'] })); };
var simpleTabsSx = function (theme) { return (__assign(__assign({}, minimalTabsSx(theme)), { backgroundColor: 'transparent', flexWrap: 'nowrap', minWidth: 'fit-content', '& .MuiButtonBase-root': {
        '&:first-child': {
            paddingLeft: 0,
        },
        '&:last-child': {
            paddingRight: 0,
        },
    } })); };
var simpleTabIndicatorSx = {
    backgroundColor: 'transparent',
};
var tabTruncateSx = {
    minWidth: 0,
    maxWidth: '200px',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
var tabWithIndicatorSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: backrs.spacing['spacing-xs'],
    });
};
var closableTabSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        pr: backrs.spacing['spacing-none'],
    });
};
var numberedTabLabelSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: backrs.spacing['spacing-md'],
    });
};
var numberedTabCircleSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: ICON_SIZES['24px'],
        height: ICON_SIZES['24px'],
        borderRadius: backrs.radius['radius-full'],
        backgroundColor: backrs.colors['Brand/50'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: backrs.colors['Brand/700'],
        border: "1px solid ".concat(backrs.colors['Brand/200']),
    });
};
var tabCloseButtonSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-xs'],
        opacity: 0,
        transition: 'opacity 0.15s ease-in-out',
        '.MuiTab-root:hover &': {
            opacity: 0.6,
        },
        '&:hover': {
            opacity: 1,
            backgroundColor: backrs.colors['Gray/100'],
        },
        '@media (max-width: 900px)': {
            opacity: 0.6,
        },
    });
};
